// API configuration for SRF Session Finder
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
// CF_WORKER_URL: Cloudflare Worker for fast session reads. Falls back to Railway if not set.
const CF_WORKER_URL = process.env.REACT_APP_CF_WORKER_URL || API_URL;

const API_ROUTES = {
  // Session endpoints — served by Cloudflare Worker (fast, low-latency)
  sessionLevels: `${CF_WORKER_URL}/api/session-levels`,
  sessionsFilter: `${CF_WORKER_URL}/api/sessions/filter`,

  // All other endpoints — served by Railway
  preferences: `${API_URL}/api/preferences`,
  preferenceAction: `${API_URL}/api/preference`,
  health: `${API_URL}/health`,
  sendVerificationCode: `${API_URL}/api/send-verification-code`,
  sendPushNotification: `${API_URL}/api/send-test-push`
};

export default API_ROUTES;
